import { format, isToday, isThisYear } from 'date-fns';
import { fr } from 'date-fns/locale';

/**
 * Format a timestamp as an age-scaled label, shared by the chat bubbles
 * (`V3MessageBubble`) and the conversation-history sidebar
 * (`GlobalConversationSidebar`) so both read identically:
 * - today              → `HH:mm`       (the time is what's relevant)
 * - earlier this year  → `j MMM`       (e.g. « 3 juin »)
 * - a previous year    → `j MMM yyyy`  (e.g. « 3 juin 2024 »)
 *
 * Accepts a `Date`, an ISO string, or an epoch number — API payloads carry
 * timestamps as strings, while in-memory message elements carry `Date`s.
 */
export function formatAdaptiveTimestamp(value: Date | string | number): string {
  const date = value instanceof Date ? value : new Date(value);
  if (isToday(date)) return format(date, 'HH:mm', { locale: fr });
  if (isThisYear(date)) return format(date, 'd MMM', { locale: fr });
  return format(date, 'd MMM yyyy', { locale: fr });
}
